import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export function WasteForm({ stockItems, onClose, authAxios }) {
  const [stockId, setStockId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const selected = stockItems.find(s => s.id === stockId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAxios.post("/stock/waste", {
        stock_id: stockId,
        quantity: parseFloat(quantity),
        reason,
      });
      toast.success("Desperdicio registrado");
      onClose();
    } catch {
      toast.error("Error");
    }
    setLoading(false);
  };

  return (
    <>
      <DialogHeader><DialogTitle>Registrar Desperdicio</DialogTitle></DialogHeader>
      <form onSubmit={handleSubmit} className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label>Ingrediente</Label>
          <Select value={stockId} onValueChange={setStockId}>
            <SelectTrigger><SelectValue placeholder="Seleccionar..." /></SelectTrigger>
            <SelectContent>
              {stockItems.map(s => (
                <SelectItem key={s.id} value={s.id}>
                  {s.name} ({s.current_quantity} {s.unit})
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>Cantidad perdida ({selected?.unit || "?"})</Label>
          <Input type="number" step="0.01" value={quantity} onChange={e => setQuantity(e.target.value)} required />
        </div>
        <div className="space-y-2">
          <Label>Motivo</Label>
          <Input value={reason} onChange={e => setReason(e.target.value)} placeholder="Vencido, caido, etc." />
        </div>
        <DialogFooter>
          <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
          <Button type="submit" disabled={loading || !stockId} className="bg-red-600 hover:bg-red-700">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Registrar"}
          </Button>
        </DialogFooter>
      </form>
    </>
  );
}
